export interface MinimalUser { role: string }

/**
 * Where to redirect a visitor of an admin route, or null if allowed.
 * Unauthenticated and non-admin users both go to "/" — the app root renders
 * the login form when unauthenticated and the chat UI otherwise. (There is no
 * standalone "/login" route, so redirecting there would render a blank page.)
 */
export function adminRedirect(user: MinimalUser | null): string | null {
  if (user === null || user.role !== "admin") return "/";
  return null;
}
